const HeaderStyle = `
  /*==========헤더==========*/
    #header {
      position:fixed;
      top:0;
      left:0;
      background: #fff;
      width: 100%;
      height: 56px;
      z-index: 1001;
      box-sizing: border-box;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
    }
    #header .header {
      width:100%;
      height:56px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      transition: all 0.3s;
    }
    #header .header.on { top:0; box-sizing: border-box; transition: all 0.3s;}
    #header .header > a {
      max-height: 40px;
      width: 100%;
      max-width: 240px;
      position: relative;
      height: 40px;
    }
    #header .header > a > img {max-width: inherit; max-height: inherit; position:absolute; top:50%; left:0; transform:translateY(-50%);}
    #header.videofixed { border-bottom: 1px solid #fff; background:#fff; box-shadow:none; }
    .menu_call_box{
      position:fixed;
      top:0;
      right:75px;
      background:#111111;
      border-radius: 0 0 4px 4px;
      box-shadow: 2px 2px 8px 0 rgba(106, 106, 248, 0.45);
      padding:29px 10px 13px 10px;
    }
    .menu_call_box span{
      color:#fff;
      font-size:18px;
      font-weight:bold;
      line-height:normal;
    }
    .menubtn {
      position: fixed;
      top: 0;
      right: 20px;
      width: 50px;
      height: 65px;
      line-height: 10px;
      background: #6a6af8;
      box-shadow: 2px 2px 8px 0px rgba(106, 106, 248, 0.45);
      border-radius: 0 0 2px 2px;
      cursor: pointer;
      z-index: 1002;
      transition: all 0.3s;
      padding: 0;
    }
    .menubtn.on { width: 50px; height: 50px;}
    .menubtn.on .line_box { margin: 0 auto;}
    .line_box {
      position: relative;
      width: 40px;
      height: 40px;
      margin: 20px auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      transition: all 0.3s;
    }
    
    .line_box .line {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 22px;
      height: 3px;
      background: #fff;
      margin: 0 auto;
      transition: all 0.3s;
    }  
    .line_box .line1 { transform: translate(-50%, -9.5px);}
    .line_box .line3 { transform: translate(-50%, 6.5px);}
    .menubtn.on .line_box .line1 { transform: translate(-50%, -50%) rotate(45deg);}
    .menubtn.on .line_box .line2 {
      width: 4px;
      height: 4px;
      background: #6a6af8;
      top: 21px;
      left: 21px;
      border-radius: 0;
    }
    .menubtn.on .line_box .line3 { transform: translate(-50%, -50%) rotate(-45deg);}
    .header-freeze {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: transparent;
      z-index: -1;
      transition: all 0.3s;
    }
    .header-freeze.on {
      display: block;
      z-index: 200;
      background: rgba(0, 0, 0, 0);
      transition: all 0.3s;
    }
    .header .menu_box.on .line_box .line1 { position: absolute; transform: rotate(90deg); }
    /*===========헤더 메뉴 버튼===========*/
    .header .menubtn{position:unset; width:40px; height: 40px; background: transparent; margin:0; border-radius:0; box-shadow:none;}
    .header .line_box{margin:0 auto;}
    .header .line_box .line{background:#464F60;}
    .header .menubtn.on .line_box .line2{display:none;}
    .menu_box {
      position: fixed;
      top: -100%;
      right: 0;
      z-index: 999;
      width: 300px;
      border-top: 2px solid #6a6af8;
      background: #fff;
      box-shadow: 3px 6px 20px 0 rgba(0, 0, 0, 0.16);
      transition: all 0.3s;
      color: #666;
      box-sizing: border-box;
      overflow-y: auto;
      max-height: 100%;
    }
    .menu_box.on { top: 0; transition: all 0.3s; }
    .menu_box > li { position: relative; padding: 14px 20px; border-bottom: 1px solid #eeeeee;}
    .menu_box_loginfo,
    .menu_box_list_li,
    .m_header_survey{display:none;}
    .menu_box_info p {
      font-size: 12px;
      color: #666;
      margin-bottom: 4px;
      line-height: 1.86;
    }
    .menu_box_info span {
      font-size: 18px;
      line-height: 1.33;
      display: block;
      font-weight: bold;
      color: #333;
    }
    
    .menu_box_list a,
    .menu_box_loginfo span {
      display: block;
      width:100%;
      line-height: 1;
      text-align: left;
      color: #666666;
      cursor: pointer;
      font-size:16px;
      padding: 10px 0;
    }
    .menu_box_list > ul > li { display: flex;  align-items: center;}
    .menu_box_loginfo span { padding: 10px 0; }
    .menu_box_loginfo img {
      display: inline-block;
      padding-right: 30px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
    
    .menu_container,.menu_container .menu_container_ul{display:flex; align-items:center;}
    .menu_container .menu_container_ul li{margin-right:30px;}
    .menu_container .menu_container_ul li a{
      font-size: 15px;
      text-align: right;
      color: #333;
      cursor:pointer;
    }
    /*======헤더 모바일 가로=====*/
    @media (max-width: 767px) and (orientation: portrait) {
      .menubtn {
        position: absolute;
        top: 0;
        right: 20px;
      }
      
    }
    /*======헤더 모바일======*/
    @media (max-width: 767px) and (orientation: portrait) {
      #header{position:sticky; box-shadow:none}
      #header .header{padding:8px 20px 8px 20px;}
      #header .header > a {  max-width:160px; max-height: 40px; width: inherit; }
      .header_wrap { padding-top: 100px;}
      .header_wrap h2 { font-size: 28px;}
      .menubtn {
        position: fixed;
        width: 40px;
        height: 50px;
        border-radius: 0 0 2px 2px;
      }
      .menubtn.on { width: 40px; z-index: 1000;}
      .line_box { width: 100%; height: 40px; margin-top: 10px;}
      .line_box.on { z-index: 1000;}
      .header_wrap .mypage_list li { margin-right: 30px;}
      .menu_box {
        position: fixed;
        top: -900px;
        right: 0;
        width: 100%;
        max-height: 100vh;
        overflow-y: auto;
      }
      .menu_box.on { top: 0;}
      .menu_container .menu_container_ul,
      .main_inform_text{display:none;}
      .menu_box{position:fixed;}
      .menu_box_loginfo,
      .menu_box_list_li,
      .m_header_survey{display:block; cursor:pointer;}
      .m_header_survey{margin-right:10px;}
    }
`
export default HeaderStyle